import Layout from '@src/components/layout/Layout';
import PrivateRoute from '@src/contexts/auth/protectedRoute';
import About from '@src/pages/about';
import Conditions from '@src/pages/conditions';
import PrivacyCookie from '@src/pages/privacyCookie';
import React, { lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';

const Success = lazy(() => import('@src/pages/success/index'));
const NotFound404 = lazy(() => import('@src/pages/notFound'));
const Contact = lazy(() => import('@src/pages/contact/index'));
const Journey = lazy(() => import('@src/pages/journey/index'));
const Paperless = lazy(() => import('@src/pages/paperless/index'));
const Login = lazy(() => import('@src/pages/login/index'));
const Dashboard = lazy(() => import('@src/pages/dashboard/index'));

const Router = () => {
    return (
        <>
            <Suspense fallback={<div>Loading...</div>}>
                <Switch>
                    <Route exact={true} path="/">
                        <Layout>
                            <Suspense fallback={<div>Loading...</div>}>
                                <Login />
                            </Suspense>
                        </Layout>
                    </Route>
                    <Route exact={true} path="/about">
                        <Layout>
                            <Suspense fallback={<div>Loading...</div>}>
                                <About />
                            </Suspense>
                        </Layout>
                    </Route>
                    <Route exact={true} path="/contact">
                        <Layout>
                            <Suspense fallback={<div>Loading...</div>}>
                                <Contact />
                            </Suspense>
                        </Layout>
                    </Route>
                    <Route exact={true} path="/privacy-cookie">
                        <Layout>
                            <Suspense fallback={<div>Loading...</div>}>
                                <PrivacyCookie />
                            </Suspense>
                        </Layout>
                    </Route>
                    <Route exact={true} path="/conditions">
                        <Layout>
                            <Suspense fallback={<div>Loading...</div>}>
                                <Conditions />
                            </Suspense>
                        </Layout>
                    </Route>
                    <PrivateRoute exact={true} path="/new-contract">
                        <Layout>
                            <Suspense fallback={<div>Loading...</div>}>
                                <Journey />
                            </Suspense>
                        </Layout>
                    </PrivateRoute>
                    <PrivateRoute exact={true} path="/dashboard">
                        <Layout>
                            <Suspense fallback={<div>Loading...</div>}>
                                <Dashboard />
                            </Suspense>
                        </Layout>
                    </PrivateRoute>
                    <PrivateRoute exact={true} path="/paperless">
                        <Layout>
                            <Suspense fallback={<div>Loading...</div>}>
                                <Paperless />
                            </Suspense>
                        </Layout>
                    </PrivateRoute>
                    <PrivateRoute exact={true} path="/success">
                        <Layout>
                            <Suspense fallback={<div>Loading...</div>}>
                                <Success />
                            </Suspense>
                        </Layout>
                    </PrivateRoute>
                    <Route path="*">
                        <Layout>
                            <Suspense fallback={<div>Loading...</div>}>
                                <NotFound404 />
                            </Suspense>
                        </Layout>
                    </Route>
                </Switch>
            </Suspense>
        </>
    );
};

export default Router;
